import script from "./Siding07Soffit.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding07Soffit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__